export enum CommonEndpointKeys {
  ENABLE_LANGUAGE_SELECTION_MODAL = 'ENABLE_LANGUAGE_SELECTION_MODAL'
}
